<template>
  <div class="item6">
    <div class="titleAfter">大脑疲劳度</div>
    <div class="chartItem">
      <div style="display: flex; justify-content: flex-end;margin-right: 10px;">
        <div style="margin: 20px 10px" class="chartTitle1">危险</div>
        <div style="margin: 20px 10px" class="chartTitle2">注意</div>
        <div style="margin: 20px 10px" class="chartTitle3">轻微</div>
        <div style="margin: 20px 10px" class="chartTitle4">健康</div>
      </div>
      <div
        ref="chartRef"
        style="width: 450px; height: 205px; border-radius: 15px"
      ></div>
    </div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { ref, reactive, onMounted } from "vue";
let chartInstance;
const chartRef = ref(null);
const option = {
  backgroundColor: "#fff", // 设置背景颜色
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["0.21", "0.42", "0.64", "0.85","1.06","1.08","1.16"],
    splitLine: {
      show: true,
    },
  },
  yAxis: {
    type: "value",
    splitLine: {
      show: true,
    },
  },
  series: [
    {
      name: "危险",
      type: "line",
      stack: "Total",
      smooth: true, // 让线条平滑
      data: [0,20,40,10,50,60,100],
      lineStyle: {
        width: 2, // 线条宽度
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#ff0000" }, // 渐变起始颜色
          { offset: 1, color: "#ffffff" }, // 渐变终止颜色
        ]),
      },
    },
  ],
};

const init = () => {
  chartInstance = echarts.init(chartRef.value);
  option && chartInstance.setOption(option);
};
onMounted(() => {
  init();
});
</script>

<style lang="scss" scoped>
.titleAfter {
  position: relative;
  color: #6cc6f3;
  padding-left: 10px;
  margin-bottom: 20px;
}
.titleAfter::after {
  content: "";
  position: absolute;
  left: -4px;
  top: 4px;
  width: 10px;
  height: 10px;
  background: #6cc6f3;
  border-radius: 50%;
}
.chartItem {
  width: 730px;
  height: 250px;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 15px;
  overflow: hidden;
}
.chartTitle1 {
  color: #fe5578;
  position: relative;
}
.chartTitle1::after {
  content: "";
  position: absolute;
  left: 4px;
  top: -12px;
  width: 20px;
  height: 8px;
  background: #fe5578;
}
.chartTitle2 {
  color: #ffca14;
  position: relative;
}
.chartTitle2::after {
  content: "";
  position: absolute;
  left: 4px;
  top: -12px;
  width: 20px;
  height: 8px;
  background: #ffca14;
}
.chartTitle3 {
  color: #2cba83;
  position: relative;
}
.chartTitle3::after {
  content: "";
  position: absolute;
  left: 4px;
  top: -12px;
  width: 20px;
  height: 8px;
  background: #2cba83;
}
.chartTitle4 {
  color: #23cefd;
  position: relative;
}
.chartTitle4::after {
  content: "";
  position: absolute;
  left: 4px;
  top: -12px;
  width: 20px;
  height: 8px;
  background: #23cefd;
}
</style>
